import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { GatewayCleanupResponse } from "@src/types/namespace-configuration";

export interface CleanupGatewayResult {
  success: boolean;
  data?: GatewayCleanupResponse;
  error?: string;
}

export const cleanupGatewayUseCase = async (
  gatewayId: string,
): Promise<CleanupGatewayResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.cleanupGateway(namespace, gatewayId);

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to clean up gateway").message,
    };
  }
};
